export default {"src":"/_next/static/media/SubDesc4.daf0e361.svg","height":201,"width":200,"blurWidth":0,"blurHeight":0};